module.exports = __webpack_public_path__ + "static/media/Riverview Homes (Niagara) Ltd. - Compliance Order - March 10 2023.07cd9861.pdf";